
























































import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import FormConsent from "@/common/components/organisms/FormConsent.vue";
import InputCheckBox from "@/common/components/atoms/InputCheckBox.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

extend("consentRequired", {
  ...required
});

@Component({
  components: {
    TheTemplateM,
    FormConsent,
    InputCheckBox,
    ButtonMain,
    ValidationProvider,
    ValidationObserver
  }
})
export default class TermsOfService extends Vue {
  ischeckBoxDisabled = true;
  consent: any = "";
  consent_time!: any;
  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page",
      pageType: "lower"
    },
    {
      text: "個人情報同意確認",
      url: "/",
      pageType: "lower"
    }
  ];

  @Watch("consent")
  Consent() {
    this.consent_time = Date.now();
  }

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      this.$refs.form as Vue & { submit: () => any };
    });
  }
  submitPage() {
    window.location.href = "/personal-information";
  }
  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.getBreadcrumb(this.breadcrumb);
  }

  onCheckConsent() {
    if (this.consent === "") {
      this.consent = 1;
    } else {
      this.consent = "";
    }
  }

  enableCheckbox() {
    this.ischeckBoxDisabled = false;
  }
}
